'use strict';

var React = require('react');
var _toConsumableArray = require('@babel/runtime/helpers/toConsumableArray');
var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var _without = require('lodash/fp/without');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);
var _without__default = /*#__PURE__*/_interopDefaultLegacy(_without);

/**
 * Action names collection
 * @example
 * import { Actions } from './DialogReducer';
 * dispatch({ type: Actions.DIALOG_CLOSE})
 * dispatch({ type: Actions.DIALOG_OPEN})
 * */
exports.Actions = void 0;
(function (Actions) {
  Actions["DIALOG_CLOSE"] = "DIALOG_CLOSE";
  Actions["DIALOG_OPEN"] = "DIALOG_OPEN";
})(exports.Actions || (exports.Actions = {}));
var initialState = {
  open: []
};
var DialogReducer = function DialogReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case exports.Actions.DIALOG_CLOSE:
      {
        var id = action.id;
        var nextOpen = _without__default["default"]([id], state.open);
        return _objectSpread__default["default"](_objectSpread__default["default"]({}, state), {}, {
          open: nextOpen
        });
      }
    case exports.Actions.DIALOG_OPEN:
      {
        var _id = action.id;
        return _objectSpread__default["default"](_objectSpread__default["default"]({}, state), {}, {
          open: [].concat(_toConsumableArray__default["default"](state.open), [_id])
        });
      }
    default:
      return state;
  }
};

var DialogContext = /*#__PURE__*/React.createContext({
  state: initialState,
  dispatch: function dispatch(a) {}
});
var useDialogContext = function useDialogContext() {
  return React.useContext(DialogContext);
};

exports.DialogContext = DialogContext;
exports.DialogReducer = DialogReducer;
exports.initialState = initialState;
exports.useDialogContext = useDialogContext;
//# sourceMappingURL=DialogContext-26c9ead4.js.map
